<template>
    <div class="spotlight-result-item" :class="{ 'spotlight-result-item--focused': focused }" @click="$emit('select', item)">
        <div class="spotlight-result-icon spotlight-result-icon--workorder">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>
        </div>
        <div class="spotlight-result-text">
            <div class="spotlight-result-title">{{ item.title }}</div>
            <div v-if="item.subtitle || status" class="spotlight-result-subtitle">
                <span v-if="status" class="spotlight-status-badge spotlight-status-badge--inline" :class="'spotlight-status--' + statusClass">{{ status.label }}</span><span v-if="status && item.subtitle" class="spotlight-inline-sep">&middot;</span><span class="spotlight-result-subtitle-text">{{ item.subtitle }}</span>
            </div>
        </div>
        <div class="spotlight-result-meta">
            <template v-if="payment">
                <span class="spotlight-payment-total">{{ formatCurrency(payment.total) }}</span>
                <span v-if="payment.remaining > 0" class="spotlight-result-payment">
                    <span class="spotlight-payment-amount">{{ formatCurrency(payment.remaining) }} {{ $t('common.spotlight.remaining') }}</span>
                    <span class="spotlight-payment-sep">&middot;</span>
                    <span class="spotlight-status-badge spotlight-status-badge--small" :class="'spotlight-status--' + paymentClass">{{ payment.status.label }}</span>
                </span>
                <span v-else class="spotlight-status-badge spotlight-status-badge--small" :class="'spotlight-status--' + paymentClass">{{ payment.status.label }}</span>
            </template>
            <span v-else class="spotlight-result-meta-muted">{{ $t('common.spotlight.noPaymentInfo') }}</span>
        </div>
    </div>
</template>

<script>
const VWO_STATUS_CLASS = {
    1: 'open',
    2: 'processing',
    3: 'completed',
    4: 'waiting',
    5: 'cancelled',
    6: 'refunded',
}

const PAYMENT_STATUS_CLASS = {
    0: 'pending',
    1: 'partial',
    2: 'paid',
    3: 'refunded',
    4: 'cancelled',
}

export default {
    name: 'VehicleWorkOrderResult',
    props: { item: Object, focused: Boolean },
    emits: ['select'],
    computed: {
        status() {
            return this.item.meta?.status || null
        },
        statusClass() {
            return VWO_STATUS_CLASS[this.status?.id] || 'open'
        },
        payment() {
            return this.item.meta?.payment || null
        },
        paymentClass() {
            return PAYMENT_STATUS_CLASS[this.payment?.status?.id] || 'pending'
        }
    },
    methods: {
        formatCurrency(val) {
            if (val == null) return ''
            return '₺' + val.toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
        }
    }
}
</script>
